import { useMemo, useState } from "react";

// Stato di visibilità dei dialog del planner con config memoizzate (niente oggetti inline nelle props)
export function usePlannerDialogs() {
  const [showNewMonth, setShowNewMonth] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [showMaster, setShowMaster] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const showConfig = useMemo(
    () => ({ newMonth: showNewMonth, import: showImport, master: showMaster, menu: showMenu }),
    [showNewMonth, showImport, showMaster, showMenu]
  );
  // i setter di useState sono stabili: la mappa non cambia mai
  const dialogClosers = useMemo(
    () => ({ newMonth: setShowNewMonth, import: setShowImport, master: setShowMaster, menu: setShowMenu }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const openDialog = (key) => dialogClosers[key](true);
  const closeDialog = (key) => dialogClosers[key](false);

  return { showConfig, openDialog, closeDialog };
}
